import React from 'react'
import { Box, Text, Paper, Flex, CopyButton, Tooltip, ThemeIcon, Group, Button } from '@mantine/core'
import { IconCheck, IconCopy, IconWindowMaximize } from '@tabler/icons-react'

const FormShareOrder = ({ idOrder, onCloseModal }) => {
  const apiUrl = process.env.REACT_APP_SERVER_API_URL

  const openNewTab = (url) => {
    window.open(`${url}`, '_blank')
  }

  const handleApiUrl = (api) => {
    if (api.includes('api2dev')) {
      return 'https://app-dev.asiacommerce.net'
    } else {
      return 'https://app.asiacommerce.net'
    }
  }

  return (
    <Box>
      <Box>
        <Paper shadow="sm" withBorder p="lg" mb='lg'>
          <Text fz={14} fw='600' mb={12}>Order Detail URL for User</Text>
          <Text fz={12} fw='500' c='gray.6' mb={1}>Order URL</Text>
            <Flex gap={4} align='center'>
              <Text fz={12} c='blue.9'>{`${handleApiUrl(apiUrl)}/order/${idOrder}`}</Text>
              <CopyButton value={`${handleApiUrl(apiUrl)}/order/${idOrder}`} timeout={2000}>
                {({ copied, copy }) => (
                  <Tooltip label={copied ? 'Copied' : 'Copy'} withArrow position="top">
                    <ThemeIcon color={copied ? 'teal' : 'blue.9'} variant="subtle" onClick={copy} size='xs'>
                      {copied ? <IconCheck size={12} /> : <IconCopy size={12} />}
                    </ThemeIcon>
                  </Tooltip>
                )}
              </CopyButton>
              <Tooltip label='Open Link' withArrow position="top">
                <ThemeIcon color='blue.9' variant="subtle" size='xs' onClick={() => openNewTab(`${handleApiUrl(apiUrl)}/order/${idOrder}`)}>
                  <IconWindowMaximize size={12} />
                </ThemeIcon>
              </Tooltip>
            </Flex>
        </Paper>
      </Box>
      <Box mt={30}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseModal}>Close</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormShareOrder